module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "fm-title"
  }, [_vm._v("ACKNOWLEDGEMENTS")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "dropcaps"
  }, [_vm._v("T")]), _vm._v("he majority of the images in this book have been drawn from the collections held by the Online Transport Archive; these include the following: the late Geoffrey Ashwell, the late C. Carter, the late Ian L. Cormack, Barry Cross, the late D.W.K. Jones, the late R.W.A. Jones, the late J. Joyce, the late F.N.T. Lloyd-Jones, the late John McCann, the late John Meredith, the late Ronnie Stephens, the late Phil Tatt, the late Julian Thompson, the late F.E.J. Ward, the late Peter N. Williams and Ian L. Wright. The National Tramway Museum houses the negatives of the late W.A. Camwell, the late Maurice O’Connor, the late R.B. Parr and the late H.B. Priestley. As with my earlier books, I’d like to express my sincere thanks to Martin Jenkins for ideas and comments on the book.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c4bbbc5e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/05_Acknowledgements.vue
// module id = 72
// module chunks = 0